import type { Auth0ContextInterface } from '@auth0/auth0-react';

export type Auth0Functions = Partial<
  Pick<Auth0ContextInterface, 'logout' | 'getAccessTokenSilently'>
>;

export const auth0Functions: Auth0Functions = {};
